module.exports = __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_FR_RGB_blk_100517.2cfdd0a7.svg";